import React from 'react';
import Modal from 'react-modal';
import style from './DiscordModal.module.less';

import x from './assets/x.png';

interface DiscordModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const DiscordModal: React.FC<DiscordModalProps> = (props) => {
  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={() => props.onClose()}
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)'
        }
      }}
      contentLabel="Newsletter Modal"
    >
      <div className={style.modalContent}>
        <div className={style.row}>
          <div className={style.content}>
            <h2>Join our Discord</h2>
            <button className={style.close} type="button" onClick={() => props.onClose()}>
              <img src={x} alt="close" />
            </button>
            <p>Become part of our community and enjoy exclusive perks, including:</p>
            <ul>
              <li>Connect with other players to team up and play</li>
              <li>Be the first to hear about new game releases</li>
              <li>Get updates on major developments and patches</li>
              <li>Access special discounts</li>
              <li>Enjoy sneak peeks into our development process</li>
              <li>Participate in playtests for our upcoming titles</li>
              <li>Enter giveaways for a chance to win free copies of our games</li>
            </ul>
            <p>Join us and be part of the adventure!</p>
            <a href="https://discord.gg/QwazPb3QeY" target="_blank">
              <button type="submit" className={style.joinDiscord}>
                Join our Discord
              </button>
            </a>
          </div>
        </div>
      </div>
    </Modal>
  );
};
